import React from 'react';
import styled from 'styled-components';
import { Glyphicon } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitterSquare } from '@fortawesome/free-brands-svg-icons';

export const OptionVerticalIcon = ({...props})=><Glyphicon glyph="option-vertical" {...props}/>;
export const RemoveIcon = ({...props})=><Glyphicon glyph="remove" {...props}/>;
export const ChevronLeft = ({...props})=><Glyphicon glyph="chevron-left" {...props}/>;
export const ChevronRight = ({...props})=><Glyphicon glyph="chevron-right" {...props}/>;
export const ChevronDownIcon = ({...props})=><Glyphicon glyph="chevron-down" {...props}/>;
export const ChevronUpIcon = ({...props})=><Glyphicon glyph="chevron-up" {...props}/>;
export const ArrowUpIcon = ({...props})=><Glyphicon glyph="arrow-up" {...props}/>;
export const ArrowDownIcon = ({...props})=><Glyphicon glyph="arrow-down" {...props}/>;
export const SearchIcon = ({...props})=><Glyphicon glyph="search" {...props}/>;
export const ArrowLeftIcon = ({...props})=><Glyphicon glyph="arrow-left" {...props}/>;
export const ThumbsUpIcon = ({...props})=><Glyphicon glyph="thumbs-up" {...props}/>;
export const StarIcon = ({...props})=><Glyphicon glyph="star" {...props}/>;
export const PlayIcon = ({...props})=><Glyphicon glyph="play" {...props}/>;
export const PlayCircleIcon = ({...props})=><Glyphicon glyph="play-circle" {...props}/>;
export const UserIcon = ({...props})=><Glyphicon glyph="user" {...props}/>;
export const TimerIcon = ({...props})=><Glyphicon glyph="time" {...props}/>;
export const OkSignIcon = ({...props})=><Glyphicon glyph="ok-sign" {...props}/>;
export const RefreshIcon = ({...props})=><Glyphicon glyph="refresh" {...props}/>;
export const LoginIcon = ({...props})=><Glyphicon glyph="log-in" {...props} />;
export const LogoutIcon = ({...props})=><Glyphicon glyph="log-out" {...props} />;
export const MenuHamburger = ({...props})=><Glyphicon glyph="menu-hamburger" {...props}/>;
export const PlusIcon = ({...props})=><Glyphicon glyph="plus" {...props}/>;
export const MinusIcon = ({...props})=><Glyphicon glyph="minus" {...props}/>;
export const TrashIcon = ({...props})=><Glyphicon glyph="trash" {...props}/>;
export const MenuDownIcon = ({...props})=><Glyphicon glyph="menu-down" {...props}/>;
export const MenuRightIcon = ({...props})=><Glyphicon glyph="menu-right" {...props}/>;
export const PencilIcon = ({...props})=><Glyphicon glyph="pencil" {...props}/>;
export const InfoIcon = ({...props})=><Glyphicon glyph="info-sign" {...props}/>;
export const QuestionIcon = ({...props})=><Glyphicon glyph="question-sign" {...props}/>;
export const TriangleRightIcon = ({...props})=><Glyphicon glyph="triangle-right" {...props}/>;
export const TriangleLeftIcon = ({...props})=><Glyphicon glyph="triangle-left" {...props}/>;
export const CalendarIcon = ({...props})=><Glyphicon glyph="calendar" {...props}/>;
export const BookIcon = ({...props})=><Glyphicon glyph="book" {...props}/>;
export const OkIcon = ({...props})=><Glyphicon glyph="ok" {...props}/>;
export const StatsIcon = ({...props})=><Glyphicon glyph="stats" {...props}/>;
export const SaveIcon = ({...props})=><Glyphicon glyph="save" {...props}/>;

export const TwitterIcon = styled(FontAwesomeIcon).attrs({
	color : '#3eaded',
	icon : faTwitterSquare
})``;
